"use client";

import { EventLabels } from "@/app/constants/mix-panel-enums";
import { useMixPanel } from "@/app/context/mixPanelContext";
import { useEffect } from "react";

import { Landing } from "@/app/component/Landing";

function LandingV1() {
  const { trackEvent, mixpanelInitialized } = useMixPanel();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const allSearchParams = Object.fromEntries(urlParams.entries());

    trackEvent(EventLabels.SL_Landing_Page, {
      screen: "Landing",
      ...allSearchParams,
    });

    trackEvent(EventLabels.SL_Landing_Page_Done, { screen: "Landing" });
  }, [mixpanelInitialized]);

  return <Landing />;
}

export default LandingV1;
